import {PlainDtoModel} from '../../../../common/entity/dto/plain/plainDto.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {FormDefinitionFormModel} from '../../../../form/definition/form/api/entity/formDefinitionForm.model';
import {ReportTemplateModel} from '../../../report-template/api/entity/reportTemplate.model';

export class ReportComponentDefinitionModel implements PlainDtoModel {
    id: number;
    label: string;
    name: string;
    formDefinition: FormDefinitionFormModel;
    type: LovValueSummary;
    template: ReportTemplateModel;
}

export enum ReportComponentDefinitionType {
    HEADER = 'ACCOUNT_REPORT_COMPONENT_TYPE_HEADER',
    FOOTER = 'ACCOUNT_REPORT_COMPONENT_TYPE_FOOTER',
    SIGNATURE = 'ACCOUNT_REPORT_COMPONENT_TYPE_SIGNATURE'
}
